// extracted by mini-css-extract-plugin
export var backdrop = "_dv-1";
export var dragging = "_dv-4";
export var handle = "_dv-6";
export var handleHit = "_dv-5";
export var listEnd = "_dv-8";
export var modalRoot = "_dv-0";
export var sectionHeader = "_dv-a";
export var sheet = "_dv-3";
export var sheetHost = "_dv-2";
export var shortcutColumns = "_dv-7";
export var shortcutSection = "_dv-9";